export const productShortName = 'Battery Technology & Energy Storage — Professional Edition™';
export const productBrand = 'Battery Technology & Energy Storage';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/mv8JA6wfF5wMu8zMNW8cTW/MOCKUP_(2).png';

export const checkoutUrl = 'https://battery-technology-energy-storage.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about battery chemistry differences',
  'No more uncertain technical explanations to clients',
  'No more struggling with BESS integration concepts',
  'No more gaps in understanding energy storage applications',
  "No more limited career advancement because technical knowledge isn't documented",
];
